import { cn } from "@/common/helpers/utils";
import { motion, Transition } from "framer-motion";
import { SPARKLE_PATH, type VehicleLoaderProps } from "../loader-svg-parts";
import { VehicleOutline } from "../vehicle-outline";

const LIFT_TRANSITION: Transition = { duration: 4, ease: "easeInOut", repeat: Infinity, repeatDelay: 1 };

const SPARKLES = [
  { x: 55, y: 18, size: 1.2, delay: 0 },
  { x: 48, y: 11, size: 0.7, delay: 0.8 },
  { x: 9, y: 20, size: 0.9, delay: 1.6 },
];

export function VehicleLoaderLift({ className }: VehicleLoaderProps) {
  return (
    <svg
      viewBox="-8 4 80 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={cn("vehicle-loader-root", className)}
    >
      <motion.ellipse
        cx="32"
        cy="64.5"
        rx="26"
        ry="1"
        className="fill-primary/15"
        animate={{ scaleX: [1, 0.85, 1], opacity: [1, 0.6, 1] }}
        transition={LIFT_TRANSITION}
      />

      <g className="fill-muted-foreground/50">
        <path
          fillRule="evenodd"
          d="M-3.5 10h4a1.5 1.5 0 0 1 1.5 1.5v53a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-53a1.5 1.5 0 0 1 1.5-1.5ZM-3 12v52h3V12ZM63.5 10h4a1.5 1.5 0 0 1 1.5 1.5v53a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-53a1.5 1.5 0 0 1 1.5-1.5ZM64 12v52h3V12Z"
        />
        <path d="M-7 66h78a1 1 0 0 1 0 2h-78a1 1 0 0 1 0-2Z" />
      </g>

      <motion.g animate={{ y: [0, -5, 0] }} transition={LIFT_TRANSITION}>
        <path
          className="fill-muted-foreground/70"
          d="M2.5 51h59a.5.5 0 0 1 .5.5V53a.5.5 0 0 1-.5.5h-59A.5.5 0 0 1 2 53v-1.5a.5.5 0 0 1 .5-.5ZM0 49h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H0a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1ZM61 49h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z"
        />
        <VehicleOutline />
      </motion.g>

      {SPARKLES.map(({ x, y, size, delay }) => (
        <g key={`${x}-${y}`} transform={`translate(${x} ${y}) scale(${size})`}>
          <motion.path
            className="fill-primary motion-reduce:hidden"
            d={SPARKLE_PATH}
            animate={{ scale: [0, 1, 0], opacity: [0, 1, 0] }}
            transition={{ duration: 2.4, ease: "easeInOut", repeat: Infinity, delay }}
          />
        </g>
      ))}
    </svg>
  );
}
